import { render, staticRenderFns } from "./ChannelConfigPage.vue?vue&type=template&id=cca88672&scoped=true"
import script from "./ChannelConfigPage.vue?vue&type=script&lang=js"
export * from "./ChannelConfigPage.vue?vue&type=script&lang=js"
import style0 from "./ChannelConfigPage.vue?vue&type=style&index=0&id=cca88672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca88672",
  null
  
)

export default component.exports